import { useAuthStore } from "features/auth/store/authStore";

const useUserState = () => {
    const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
    const selectedRole = useAuthStore((s) => s.selectedRole);
    return { isLoggedIn, selectedRole };
};

export default useUserState;
